import { resolveConditionals as resolveBlocks } from "@autodromo/template-syntax";
import { resolvePath } from "./resolvePath";
import type { DynamicStructure } from "../types";

export function resolveConditionals({
  template,
  structure,
}: {
  template: string;
  structure: DynamicStructure;
}): string {
  return resolveBlocks({ template, resolve: (path) => resolvePath(structure, path) });
}
